/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Quick-add feedback for collection cards */
(function () {
  var pendingButton = null;
  var pendingTimeout = null;
  var toast = null;

  function getToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.style.cssText = 'position:fixed;z-index:99999;left:50%;bottom:24px;transform:translateX(-50%);padding:12px 18px;border-radius:4px;background:#222;color:#fff;font-size:14px;line-height:1.4;box-shadow:0 2px 12px rgba(0,0,0,.2);opacity:0;pointer-events:none;transition:opacity .15s ease;';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message) {
    var status = getToast();
    status.textContent = message;
    status.style.opacity = '1';
    window.clearTimeout(status.hideTimer);
    status.hideTimer = window.setTimeout(function () {
      status.style.opacity = '0';
    }, 2200);
  }

  function startQuickAdd(button) {
    if (!button || button.disabled) return;
    if (!button.dataset.quickAddOriginalText) {
      button.dataset.quickAddOriginalText = button.textContent.trim();
    }
    pendingButton = button;
    button.textContent = 'Adding…';
    button.setAttribute('aria-busy', 'true');
    window.clearTimeout(pendingTimeout);
    pendingTimeout = window.setTimeout(function () {
      if (pendingButton === button) {
        button.textContent = button.dataset.quickAddOriginalText;
        button.removeAttribute('aria-busy');
        pendingButton = null;
      }
    }, 12000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.product-item__action-list--quick-add-visible [data-action="add-to-cart"]');
    if (button) startQuickAdd(button);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.product-item__action-list--quick-add-visible')) return;
    startQuickAdd(form.querySelector('[data-action="add-to-cart"]'));
  });

  document.addEventListener('product:added', function () {
    if (!pendingButton) return;
    var button = pendingButton;
    window.clearTimeout(pendingTimeout);
    button.textContent = 'Added to cart';
    button.removeAttribute('aria-busy');
    showToast('Added to cart');
    window.setTimeout(function () {
      button.textContent = button.dataset.quickAddOriginalText || 'Add to cart';
      delete button.dataset.quickAddOriginalText;
    }, 2200);
    pendingButton = null;
  });
})();

/* Default every collection to in-stock products, while remembering when a shopper clears that filter. */
(function () {
  var availabilityParam = 'filter.v.availability';
  if (!document.querySelector('[data-section-type="collection"]')) return;

  var preferenceKey = 'vapesquard.collectionAvailabilityOptOut:' + window.location.pathname;

  function saveOptOut(value) {
    try {
      if (value) {
        window.sessionStorage.setItem(preferenceKey, '1');
      } else {
        window.sessionStorage.removeItem(preferenceKey);
      }
    } catch (error) {}
  }

  function hasOptedOut() {
    try {
      return window.sessionStorage.getItem(preferenceKey) === '1';
    } catch (error) {
      return false;
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.name !== availabilityParam) return;
    saveOptOut(!input.checked);
  }, true);

  document.addEventListener('click', function (event) {
    var clearButton = event.target.closest && event.target.closest('[data-action="clear-filters"]');
    if (!clearButton) return;
    if (new URLSearchParams(window.location.search).has(availabilityParam)) {
      saveOptOut(true);
    }
  }, true);

  var params = new URLSearchParams(window.location.search);
  if (params.has(availabilityParam) || hasOptedOut()) return;

  params.set(availabilityParam, '1');
  params.delete('page');
  window.location.replace(
    window.location.pathname +
    (params.toString() ? '?' + params.toString() : '') +
    window.location.hash
  );
})();
